import Static from './Static';

export default {
  Static
};



/** WEBPACK FOOTER **
 ** ./src/FormControls/index.js
 **/